<template>
  <div ref="slideMain">
    <slide-up-down :active="shown" :duration="duration">
      <slot />
    </slide-up-down>
    <button
      ref="drowerButton"
      type="button"
      class="drowerButton"
      :class="{ closeButton: shown }"
      @click.prevent="drower"
    >
      {{ openButtonName }}
    </button>
  </div>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down'

export default {
  name: 'TkAccordion',
  components: {
    SlideUpDown,
  },
  props: {
    openButtonName: {
      type: String,
      required: false,
      default: '',
    },
    closeButtonName: {
      type: String,
      required: false,
      default: '',
    },
    duration: {
      type: Number,
      required: false,
      default: 200,
    },
  },
  data() {
    return {
      shown: true,
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.shown = false
    })
  },
  methods: {
    drower() {
      if (this.shown) {
        this.$refs.drowerButton.textContent = this.openButtonName
        var scrollValue =
          window.pageYOffset + this.$refs.slideMain.getBoundingClientRect().top
        scrollValue -= window.outerHeight / 2

        const interval = 2
        const step = -scrollValue / Math.ceil(this.duration / interval)
        const timer = setInterval(() => {
          window.scrollBy(0, step)
          if (window.scrollY <= scrollValue) {
            clearInterval(timer)
          }
        }, interval)
      } else {
        this.$refs.drowerButton.textContent = this.closeButtonName
      }
      this.shown = !this.shown
    },
  },
}
</script>

<style lang="scss">
@import '~@ota-frontend/ui/src/scss/components/TkAccordion.scss';
</style>
